// MainCategorySeoTable.js - Wrapper Component
import React from "react";
import SeoTable from "./components/SeoTable";

function MainCategorySeoTable() {
  return <SeoTable entityType="main-category" />;
}

export default MainCategorySeoTable;
